import { Dialog, DialogTitle, DialogPanel } from "@headlessui/react";
import { useState } from "react";

export default function LocationWithMap({ isOpen, onClose }) {
  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="bg-white rounded-md p-4 max-w-2xl w-full shadow-lg">
            <DialogTitle className="text-lg font-semibold mb-4">
              Map - Springfield Centre
            </DialogTitle>
            <iframe
              src="https://www.google.com/maps?q=Springfield+Centre+Tallaght&output=embed"
              width="100%"
              height="400"
              allowFullScreen
              loading="lazy"
              className="rounded-md border"
            ></iframe>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
